// removed by extract-text-webpack-plugin
module.exports = {"flexWrapper":"TaskTemplateBlockOverview__flexWrapper__3bKq9"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockOverview.scss
// module id = 1787
// module chunks = 0